import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1688cc72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StatisticalEmp" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "pv" }
const _hoisted_4 = { class: "uv" }
const _hoisted_5 = { class: "ip" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { toDay, secondToMin } from '@/utils/date-format'
import { useRouter } from 'vue-router'

import { useStore } from '@/store'
import { queryStatistical } from '@/service/main/fubo/statitiscal'
import { ref } from 'vue'
import {initEmptyParam} from "@/hooks/useInitParam";
import localCache from "@/utils/cache";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticalEmp',
  setup(__props) {

initEmptyParam()
const store = useStore()
const userInfo = store.state.login.userInfo

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.id};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'empIds')
  userItem!.options = userOptions;
}
getEmp()

const queryParam = {
  empIds: userInfo.id,
  accessTime: [toDay(), toDay()]
}
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}

const router = useRouter()
const statitiscal = ref({ pv: 0, uv: 0, ip: 0 })

const searchCb = async (item: any) => {
  statitiscal.value = await queryStatistical(item)
}

searchCb({ ...queryParam, pageNo: 1, pageSize: 1000 })

const handleEmp = (item: any) => {
  router.push({
    path: '/main/fubo/access',
    query: {
      empIds: item.empId,
      accessTime: store.state.system.queryInfo.accessTime
    }
  })
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb, searchCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode("总访问次数(pv): "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.pv), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createTextVNode("客户数量(uv): "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.uv), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createTextVNode("独立ip: "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.ip), 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "fuboStatisticalEmp",
      onRowClick: handleEmp,
      downFilename: "复播访问记录表-按个人.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick)
    }, {
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToMin)(scope.row.duration)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})